import {ThemeOptions, outlinedInputClasses} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiTextField = ({inputfield}: Tokens): ThemeOptions['components'] => {
  const {button, container, adornments} = inputfield;

  return {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined'
      },
      styleOverrides: {
        root: {}
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {},
        positionEnd: {
          paddingTop: adornments.desktop.icon.endright.padding.top,
          paddingRight: 0,
          paddingBottom: adornments.desktop.icon.endright.padding.bottom,
          paddingLeft: adornments.desktop.icon.endright.padding.left,
          // primary button in input field
          '& > button.MuiButton-contained': {
            height: '100%',
            minHeight: 38,
            minWidth: button.primary.desktop.width.min,
            backgroundColor: button.primary.desktop.background.color,
            borderTopRightRadius: button.primary.desktop.border.radius.topRight,
            borderBottomRightRadius: button.primary.desktop.border.radius.bottomRight,
            borderTopLeftRadius: button.primary.desktop.border.radius.topLeft,
            borderBottomLeftRadius: button.primary.desktop.border.radius.bottomLeft,
            paddingTop: button.primary.desktop.padding.top,
            paddingRight: button.primary.desktop.padding.right,
            paddingBottom: button.primary.desktop.padding.bottom,
            paddingLeft: button.primary.desktop.padding.left,
            borderColor: button.primary.desktop.border.color,
            borderStyle: button.primary.desktop.border.style,
            borderWidth: button.primary.desktop.border.width,
            color: button.primary.desktop.icon.color,
            '& .MuiSvgIcon-root': {
              height: button.primary.desktop.icon.height,
              width: button.primary.desktop.icon.width
            },
            '&:hover': {
              backgroundColor: button.primary.desktop.hover.background.color,
              color: button.primary.desktop.hover.icon.color,
              borderColor: button.primary.desktop.hover.border.color
            },
            '&:active': {
              backgroundColor: button.primary.desktop.active.background.color,
              color: button.primary.desktop.active.icon.color,
              borderColor: button.primary.desktop.active.border.color
            }
          },
          // X close button in input field
          '& .MuiButtonBase-root.inputClearButton': {
            marginTop: adornments.desktop.closebutton.margin.top,
            marginRight: adornments.desktop.closebutton.margin.right,
            marginBottom: adornments.desktop.closebutton.margin.bottom,
            marginLeft: adornments.desktop.closebutton.margin.left,
            padding: 0,
            height: 'auto',
            width: 'auto'
          },
          '& > .MuiSvgIcon-root': {
            marginRight: 14
          }
        }
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: false
      },
      styleOverrides: {
        root: {
          backgroundColor: container.desktop.background.color,
          // mui border radius override
          borderTopRightRadius: container.desktop.border.radius.topRight,
          borderBottomRightRadius: container.desktop.border.radius.bottomRight,
          borderBottomLeftRadius: container.desktop.border.radius.bottomLeft,
          borderTopLeftRadius: container.desktop.border.radius.topLeft,
          marginBottom: container.desktop.margin.bottom,
          [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: container.desktop.hover.border.color,
            borderStyle: container.desktop.hover.border.style,
            borderWidth: container.desktop.hover.border.width
          },
          [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: container.desktop.focus.border.color,
            borderStyle: container.desktop.focus.border.style,
            borderWidth: container.desktop.focus.border.width
          },
          [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: container.desktop.error.border.color,
            borderStyle: container.desktop.error.border.style,
            borderWidth: container.desktop.error.border.width
          },
          [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: container.desktop.disabled.border.color,
            borderStyle: container.desktop.disabled.border.style,
            borderWidth: container.desktop.disabled.border.width
          },
          [`&.${outlinedInputClasses.error}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: container.desktop.focus.border.color,
            borderWidth: container.desktop.focus.border.width
          }
        },
        input: {
          height: 'unset',
          backgroundColor: container.desktop.background.color,
          color: container.desktop.font.color,
          fontFamily: container.desktop.font.family,
          fontSize: container.desktop.font.size,
          lineHeight: container.desktop.font.lineHeight,
          paddingTop: container.desktop.padding.top,
          paddingRight: container.desktop.padding.right,
          paddingBottom: container.desktop.padding.bottom,
          paddingLeft: container.desktop.padding.left
        },
        notchedOutline: {
          borderColor: container.desktop.border.color,
          borderStyle: container.desktop.border.style,
          borderWidth: container.desktop.border.width
        },
        adornedEnd: {
          paddingRight: 0
        }
      }
    }
  };
};
